/*
 * Shipping text for the visitor's country and currency.
 *
 * Replaces these tokens anywhere in the page content:
 *   [amount]            free-shipping threshold: $99 in USD, and for other currencies $99 converted
 *                       with Shopify's exchange rate and rounded up to a whole unit (e.g. £74).
 *   [delivery-price]    "$4.99 US Delivery · free over $99" (US price 4.99; other countries 7.99
 *                       converted and rounded up to a whole unit, with the country code, e.g.
 *                       "£6 UK Delivery · free over £74").
 *   [delivery-dates]    real delivery date range (business days from today).
 *   [earliest-delivery] the earliest date in that range, e.g. "Oct 21".
 *                       Delivery = 1-3 days processing + 7-10 days transit in the US, or 10-14 days
 *                       transit elsewhere (the store's own shipping text): earliest = 8 business
 *                       days (US) or 11 (elsewhere) from today.
 *
 * Also exposes window.jaShip (used by the cart drawer) with the same values.
 * The shipping prices below must match the shipping rates in Shopify admin.
 */
(function () {
  var US_PRICE = 4.99;
  var INTL_PRICE = 7.99;
  var BASE_THRESHOLD = 99;

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) days--;
    }
    return d;
  }

  function ctx() {
    var info = (window.Shopify && window.Shopify.currency) || {};
    var span = document.querySelector('[data-free-ship-threshold], .free-ship-amount[data-free-ship-amount]');
    var base = BASE_THRESHOLD;
    var baseCurrency = 'USD';
    if (span) {
      base = parseFloat(span.getAttribute('data-free-ship-threshold') || span.getAttribute('data-free-ship-amount')) || BASE_THRESHOLD;
      baseCurrency = span.getAttribute('data-base-currency') || 'USD';
    }
    var active = info.active || baseCurrency;
    var rate = parseFloat(info.rate);
    var converted = active !== baseCurrency && rate > 0;
    var country = (window.Shopify && window.Shopify.country) || 'US';
    return {
      base: base,
      baseCurrency: baseCurrency,
      currency: converted ? active : baseCurrency,
      rate: rate,
      converted: converted,
      country: country,
      isUS: country === 'US',
      code: country === 'GB' ? 'UK' : country,
      lang: document.documentElement.lang || undefined
    };
  }

  function money(c, amount, whole) {
    var o = { style: 'currency', currency: c.currency };
    if (whole) { o.minimumFractionDigits = 0; o.maximumFractionDigits = 0; }
    return new Intl.NumberFormat(c.lang, o).format(amount);
  }

  function amountText(c) {
    try { return money(c, c.converted ? Math.ceil(c.base * c.rate) : c.base, true); } catch (e) { return null; }
  }

  function priceText(c) {
    try {
      var p = c.isUS ? US_PRICE : INTL_PRICE;
      return c.converted ? money(c, Math.ceil(p * c.rate), true) : money(c, p, false);
    } catch (e) { return null; }
  }

  function deliveryPriceText(c) {
    var p = priceText(c);
    var a = amountText(c);
    if (!p || !a) return null;
    return p + ' ' + c.code + ' Delivery · free over ' + a;
  }

  function dates(c) {
    try {
      var today = new Date();
      var from = addBusinessDays(today, c.isUS ? 8 : 11);
      var to = addBusinessDays(today, c.isUS ? 13 : 17);
      var fmt = new Intl.DateTimeFormat(c.lang, { month: 'short', day: 'numeric' });
      return {
        earliest: fmt.format(from),
        range: typeof fmt.formatRange === 'function' ? fmt.formatRange(from, to) : fmt.format(from) + ' – ' + fmt.format(to)
      };
    } catch (e) { return { earliest: null, range: null }; }
  }

  window.jaShip = {
    lines: function () {
      var c = ctx();
      var d = dates(c);
      return {
        delivery: deliveryPriceText(c),
        earliest: d.earliest ? 'Get it as soon as ' + d.earliest : null,
        exchange: 'Free exchanges within 30 days'
      };
    }
  };

  if (window.__shipTokensLoaded) return;
  window.__shipTokensLoaded = true;

  function run() {
    var c = ctx();
    var d = dates(c);
    var values = {
      '[amount]': amountText(c),
      '[delivery-price]': deliveryPriceText(c),
      '[delivery-dates]': d.range,
      '[earliest-delivery]': d.earliest
    };

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) {
      var n = walker.currentNode;
      if (/\[(amount|delivery-price|delivery-dates|earliest-delivery)\]/.test(n.nodeValue) && !/^(SCRIPT|STYLE|NOSCRIPT)$/.test(n.parentNode.nodeName)) nodes.push(n);
    }
    nodes.forEach(function (n) {
      var v = n.nodeValue;
      Object.keys(values).forEach(function (k) {
        if (values[k]) v = v.split(k).join(values[k]);
      });
      n.nodeValue = v;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
